const STEPS = [
  {
    num: '01',
    icon: 'ri-discuss-line',
    title: 'Consultation & Scope',
    desc: 'We visit the space, discuss your vision, and define the full scope of work. No surprises later — everything is agreed on before we start.',
    detail: 'On-site visit included',
  },
  {
    num: '02',
    icon: 'ri-delete-bin-line',
    title: 'Demo & Inspection',
    desc: 'Old materials are removed carefully. Once walls and floors are exposed, we inspect for water damage, mold, or structural issues and address them before moving forward.',
    detail: 'Hidden issues resolved first',
  },
  {
    num: '03',
    icon: 'ri-shield-check-line',
    title: 'Waterproofing',
    desc: 'This is the step most crews skip. We apply a proper waterproof membrane to all wet areas — walls, floor, niche, and transitions. This is what prevents leaks years later.',
    detail: 'Membrane on all wet surfaces',
  },
  {
    num: '04',
    icon: 'ri-layout-grid-line',
    title: 'Tile Installation',
    desc: 'Walls and floors tiled with precision — consistent joints, perfect layout lines, and full coverage adhesive. Large format or intricate patterns, we execute both cleanly.',
    detail: 'Laser-level layout',
  },
  {
    num: '05',
    icon: 'ri-home-gear-line',
    title: 'Fixtures & Finishes',
    desc: 'Shower glass, vanity, mirrors, trim, caulking, and final touches. Every element installed level, sealed, and finished — no raw edges or exposed gaps.',
    detail: 'Full finish-out included',
  },
  {
    num: '06',
    icon: 'ri-checkbox-circle-line',
    title: 'Final Walkthrough',
    desc: 'We do a full inspection with you before calling it done. Grout, caulk, glass, fixtures — everything is reviewed. If you see anything, we fix it on the spot.',
    detail: 'Client sign-off required',
  },
];

export default function BathroomProcess() {
  return (
    <section className="py-24 px-4 md:px-8 bg-[#1c1c1c]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-[#c9a55a] text-xs font-bold uppercase tracking-[0.3em] mb-4">How We Work</p>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-5">Our Remodeling Process</h2>
          <p className="text-white/45 text-base max-w-xl mx-auto leading-relaxed">
            Bathrooms are the most technical room in a home. Our six-step process makes sure
            nothing is rushed, nothing is skipped — and the result is built to last.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {STEPS.map((step, idx) => (
            <div
              key={step.num}
              className="group relative bg-[#1a1a1a] border border-white/8 hover:border-[#c9a55a]/30 rounded-2xl p-8 transition-all duration-300 overflow-hidden"
            >
              <div className="absolute top-4 right-6 text-[7rem] font-black text-white/[0.03] leading-none select-none pointer-events-none">
                {idx + 1}
              </div>

              <div className="inline-flex items-center gap-2 bg-[#c9a55a]/10 border border-[#c9a55a]/20 rounded-full px-3 py-1 mb-6">
                <span className="text-[#c9a55a] text-xs font-bold tracking-widest">{step.num}</span>
              </div>

              <div className="w-12 h-12 flex items-center justify-center bg-[#0d0d0d] border border-white/10 group-hover:border-[#c9a55a]/30 rounded-xl mb-5 transition-colors">
                <i className={`${step.icon} text-[#c9a55a] text-xl`} />
              </div>

              <h3 className="text-white font-black text-xl mb-3">{step.title}</h3>
              <p className="text-white/50 text-sm leading-relaxed mb-5">{step.desc}</p>

              <div className="flex items-center gap-2 border-t border-white/8 pt-4">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-arrow-right-s-line text-[#c9a55a] text-sm" />
                </div>
                <span className="text-[#c9a55a] text-xs font-semibold">{step.detail}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
